import { __,_x } from '@wordpress/i18n';
import {PanelBody} from '@wordpress/components';
import {useState} from '@wordpress/element';
import { SlideButton } from '@vayu-blocks/global';
import {VayuBlocksDimensions, VayuBlocksAlignment, VayuBlocksBackground, 
    VayuBlocksTypography, VayuBlocksBorder} from '@vayu-blocks';
import {HeightControl} from '@vayu-blocks';

const UnfoldStylePanel = ({attributes,setAttributes, openPanels, onTogglePanel}) => {
    const [ hover, setHover ] = useState( 'normal' );

     const handelHover = (value) => {
        setHover(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }
    
    return (
        <>
                <PanelBody title={ __( 'Shadow Color', 'vayu-blocks' ) } className="th-adv-unfold-button-wrapper-style-panel" opened={openPanels['Style-color']} onToggle={() => onTogglePanel('Style-color')} >

                    <VayuBlocksBackground
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        colorPanel = {[
                            {
                                active: ['color'],
                                label: 'Content Top Color',
                                key:'contentGradient',
                                value:attributes.contentGradient
                            },
                             {
                                active: ['color'],
                                label: 'Content Bottom Color',
                                key:'contentGradientbo',
                                value:attributes.contentGradientbo
                            }
                        ]}
                    />

                    <HeightControl 
                        label={__('Overlay', 'vayu-blocks')}
                        value={ attributes.contentfade }
                        onChange={ (value)=>setAttributes({contentfade:value}) }
                        responsive={true}
                        unitMax={{px: { max: 5000, step: 1 }}}
                    />

                </PanelBody>

                <PanelBody title={ __( 'Button', 'vayu-blocks' ) } className="th-adv-unfold-button-wrapper-style-panel" opened={openPanels['Style-button']} onToggle={() => onTogglePanel('Style-button')} >  
                        <VayuBlocksAlignment
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            setAttributes={setAttributes}
                            alignment = {{key:'align',value:attributes.align}}
                        />

                        <VayuBlocksTypography
                            value={attributes.typography}
                            onChange={(newValues) => {setAttributes({typography:newValues})}}
                        />

                        <VayuBlocksDimensions  
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            label={{
                                panel: __('Button', 'vayu-blocks'),
                            }}
                            dimensions={{
                                padding: { key: 'PaddingBtn', value: attributes.PaddingBtn },
                                margin: { key: 'MarginBtn', value: attributes.MarginBtn }
                            }}
                        />

                        <SlideButton  
                            button={{ normal: "Normal", hover: "Hover" }}
                            onChange={(value)=>handelHover(value)}
                            defaultValue={hover}
                        />  

                        { 'normal' ===  hover &&  (	
                      
                            <VayuBlocksBorder 
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                border={{key:'btnBorder',value:attributes.btnBorder}}
                                borderRadius={{key:'btnRadius',value:attributes.btnRadius}}
                                dropShadow = {{key:'btnShadow',value:attributes.btnShadow}}
                            />
                
                        ) || 'hover' ===  hover && (
                        
                            <VayuBlocksBorder 
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                border={{key:'btnBorderHover',value:attributes.btnBorderHover}}
                                borderRadius={{key:'btnRadiusHover',value:attributes.btnRadiusHover}}
                                dropShadow = {{key:'btnShadowHover',value:attributes.btnShadowHover}}
                            />
                   
                        ) }

                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                                {
                                    active: ['color'],
                                    label: 'Button Color',
                                    key:'btnClr',
                                    value:attributes.btnClr
        
                                },
                                {
                                    active: ['color'],
                                    label: 'Button Hover',
                                    key:'btnHvrClr',
                                    value:attributes.btnHvrClr
                                },
                                {
                                    active: ['gradient'],
                                    label: 'Button Bg',
                                    key:'backgroundBtncolor',
                                    value:attributes.backgroundBtncolor
                                },
                                {
                                    active: ['gradient'],
                                    label: 'Button Bg Hover',
                                    key:'backgroundBtnhoverColor',
                                    value:attributes.backgroundBtnhoverColor
                                }
                            ]}
                        />
                </PanelBody> 
           
        </>
    )

}
export default UnfoldStylePanel;